import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ServiceOrdersTable from "@/components/tables/service_orders/ServiceOrdersTable.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceOrderTableView',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ServiceOrdersTable))
}
}

})